import { BusinessAccountRoleNameEnum, AccountTypeNames } from '@medentee/enums'

import { RelatedAccountsList } from 'App/components'
import { createLoadingSelector, GET_RELATED_ACCOUNTS, useAppSelector } from 'store'

export type TRelatedAccountsListContainerProps = {
  onCreateBusinessAccount: () => void
  type?: AccountTypeNames
}

const loadingSelector = createLoadingSelector([GET_RELATED_ACCOUNTS])

export const RelatedAccountsListContainer = (props: TRelatedAccountsListContainerProps) => {
  const { ids } = useAppSelector((state) => state.userProfile.relatedAccounts)
  const loading = useAppSelector(loadingSelector)
  const businessAccountsLimit = useAppSelector(
    (state) => state.global.accountData?.maxParticipationsAsSuperadmin
  )
  const relatedAccountsList = useAppSelector((state) => state.userProfile.relatedAccounts.list)

  const businessAccNumber = Object.values(relatedAccountsList).filter(
    (item) => item.role?.name === BusinessAccountRoleNameEnum.SUPERADMIN
  )

  const hasBusinessAccountsLimit = businessAccountsLimit
    ? businessAccNumber.length >= businessAccountsLimit
    : true

  return (
    <RelatedAccountsList
      {...props}
      loading={loading}
      hasBusinessAccountsLimit={hasBusinessAccountsLimit}
      ids={ids}
    />
  )
}
